/**
 * Vue touch-events
 */
import Vue2TouchEvents from 'vue2-touch-events';

export const plugin = {
    name: 'touch-events',

    install (Vue) {
        Vue.use(Vue2TouchEvents, {
            swipeTolerance: 80
        });
    }
};

export default plugin;
